'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var isString = function isString(color) {
  return typeof color === 'string';
};

var isHex = exports.isHex = function isHex(color) {
  return isString(color) && color.indexOf('#') === 0;
};

var isShortHex = exports.isShortHex = function isShortHex(color) {
  return isHex(color) && color.length === 4;
};

var isLongHex = exports.isLongHex = function isLongHex(color) {
  return isHex(color) && color.length === 7;
};

var isRgbString = exports.isRgbString = function isRgbString(color) {
  return isString(color) && color.startsWith('rgb');
};

var isRgbaColorObject = exports.isRgbaColorObject = function isRgbaColorObject(color) {
  return color.type === 'rgba';
};

var isHslString = exports.isHslString = function isHslString(color) {
  return isString(color) && color.startsWith('hsl');
};

var isHslaColorObject = exports.isHslaColorObject = function isHslaColorObject(color) {
  return color.type === 'hsla';
};

var isColorObject = exports.isColorObject = function isColorObject(color) {
  return isHslaColorObject(color) || isRgbaColorObject(color);
};

var isValidColor = exports.isValidColor = function isValidColor(color) {
  return isColorObject(color) || isString(color) && (isHex(color) || isRgbString(color) || isHslString(color));
};